// @flow

import { createContext, useContext } from 'react';

export type RequestFetchCustomReceipts = () => void;

export type CustomReceiptsFetchStatus = 'not-fetched' | 'fetching' | 'ready' | 'failed';

export type CustomReceiptsHandler = {|
  customReceiptsFetchStatus: CustomReceiptsFetchStatus,
  requestFetchCustomReceipts: RequestFetchCustomReceipts,
|};

const CustomReceiptsHandlerContext = createContext<?CustomReceiptsHandler>(null);

export function useCustomReceiptsHandlerContext(): CustomReceiptsHandler {
  const context = useContext(CustomReceiptsHandlerContext);

  if(!context) {
    throw new Error('CustomReceiptsHandler context was not provided');
  }

  return context;
}

export const CustomReceiptsHandlerProvider = CustomReceiptsHandlerContext.Provider;
